/* index.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDKxmn%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D%0A._23rrnHyKLB%7Btransition%3Avar(--ds-button-hovered%2Cbackground-color%20border-color%20.15s%20cubic-bezier(.4%2C1%2C.6%2C1))%7D%0A._1UtDYze5R3%7Bcolor%3Avar(--ds-text-inverse%2C%23fff)%7D%0A._0KLXrugozt%7Bbackground-color%3Avar(--ds-background-neutral-bold%2C%23292a2e)%7D%0A._1eOmH6kTlo%3Ahover%7Bbackground-color%3Avar(--ds-background-neutral-bold-hovered%2C%233b3d42)%7D%0A._3sFUREiSCN%3Aactive%7Btransition%3Avar(--ds-button-pressed%2Cbackground-color%20border-color%20.15s%20cubic-bezier(.4%2C1%2C.6%2C1))%7D%0A._3gzVzLVbka%3Aactive%7Bbackground-color%3Avar(--ds-background-neutral-bold-pressed%2C%23505258)%7D");






import { forwardRef, type ReactNode, useContext } from 'react';
import { Pressable, type PressableProps } from '@atlaskit/primitives/compiled/pressable';
import { Text } from '@atlaskit/primitives/compiled/text';
import { SpotlightContext } from '../../controllers/context';
const styles = {
  rootMotion: "_0bjKvDKxmn _23rrnHyKLB _1UtDYze5R3 _0KLXrugozt _1eOmH6kTlo _3sFUREiSCN _3gzVzLVbka"
};
export interface SpotlightSecondaryActionProps {
  /**
   * A `testId` prop is provided for specified elements, which is a unique
   * string that appears as a data attribute `data-testid` in the rendered code,
   * serving as a hook for automated tests
   */
  testId?: string;

  /**
   * Text to be rendered inside the `SpotlightActions`.
   */
  children: ReactNode;

  /**
   * The action to take when the button is clicked.
   */
  onClick?: PressableProps['onClick'];

  /**
   * An accessible label to read out in the event that the displayed text does not provide enough context.
   */
  'aria-label'?: string;
}

/**
 * __Spotlight secondary action__
 *
 * `SpotlightSecondaryAction` is not required for all spotlight components. It should supplement the `SpotlightPrimaryAction`.
 * It is intended to be used to go back to the previous step in multi step spotlight tours, or other similar actions.
 *
 */
export const SpotlightSecondaryAction: React.ForwardRefExoticComponent<React.PropsWithoutRef<SpotlightSecondaryActionProps> & React.RefAttributes<HTMLButtonElement>> = forwardRef<HTMLButtonElement, SpotlightSecondaryActionProps>(({
  'aria-label': ariaLabel,
  onClick,
  children,
  testId
}: SpotlightSecondaryActionProps, ref) => {
  const {
    secondaryAction
  } = useContext(SpotlightContext);
  const back: PressableProps['onClick'] = event => {
    secondaryAction.action.current(event);
  };
  return <Pressable aria-label={ariaLabel} ref={ref} testId={testId} xcss={styles.rootMotion} onClick={onClick || back}>
				<Text as="span">{children}</Text>
			</Pressable>;
});